// Personality Result Definitions
export const results = {
  sportsStar: {
    type: "sportsStar",
    emoji: "⚽",
    title: "Sports Star Mindset",
    subtitle: "Agile & Competitive Champion",
    description: "You thrive under pressure, push your limits, and execute plays with speed and agility."
  },
  spaceExplorer: {
    type: "spaceExplorer",
    emoji: "🚀",
    title: "Space Explorer Mindset",
    subtitle: "Fearless Frontier Pioneer",
    description: "You are driven by relentless curiosity to explore unknown territories and reach new heights."
  },
  gamer: {
    type: "gamer",
    emoji: "🎮",
    title: "Gamer Mindset",
    subtitle: "Tactical & Adaptive Master",
    description: "You quickly spot patterns, optimize mechanics, and level up through persistent practice."
  },
  detective: {
    type: "detective",
    emoji: "🕵️",
    title: "Detective Mindset",
    subtitle: "Sharp Analytical Observer",
    description: "You notice hidden details, connect subtle clues, and deduce truth through logic."
  },
  inventor: {
    type: "inventor",
    emoji: "🧠",
    title: "Inventor Mindset",
    subtitle: "Creative Solution Builder",
    description: "You build original devices, experiment with code/hardware, and craft new solutions."
  }
};

// 100 Short & Fast-Reading Questions Pool
export const questionPool = [
  {
    id: 1,
    question: "You spot a hidden entrance in a wall. What's your move?",
    options: [
      { text: "Sprint through before it closes!", type: "sportsStar" },
      { text: "Scan room for hidden levers or clues", type: "detective" },
      { text: "Chart the unknown path inside", type: "spaceExplorer" },
      { text: "Hack the electronic locking code", type: "inventor" }
    ]
  },
  {
    id: 2,
    question: "How do you tackle a tough obstacle?",
    options: [
      { text: "Out-speed and overpower it", type: "sportsStar" },
      { text: "Find the cheat code or trick exploit", type: "gamer" },
      { text: "Deduce its core flaw & target it", type: "detective" },
      { text: "Build a tool to bypass it easily", type: "inventor" }
    ]
  },
  {
    id: 3,
    question: "Pick your dream mission:",
    options: [
      { text: "Landing on an alien planet", type: "spaceExplorer" },
      { text: "Solving an unsolved mystery case", type: "detective" },
      { text: "Winning a championship final", type: "sportsStar" },
      { text: "Building a sentient AI robot", type: "inventor" }
    ]
  },
  {
    id: 4,
    question: "A sudden error crashes your project. Reaction?",
    options: [
      { text: "Inspect error logs for root cause", type: "detective" },
      { text: "Quick restart & retry immediately", type: "sportsStar" },
      { text: "Patch code with a custom tool", type: "inventor" },
      { text: "Respawn at the last stable save", type: "gamer" }
    ]
  },
  {
    id: 5,
    question: "Which skill is most vital?",
    options: [
      { text: "Lightning reflexes & endurance", type: "sportsStar" },
      { text: "Relentless discovery & courage", type: "spaceExplorer" },
      { text: "Strategic combo optimization", type: "gamer" },
      { text: "Sharp deduction & pattern spot", type: "detective" }
    ]
  },
  {
    id: 6,
    question: "You get a blank sheet of paper. What do you draw?",
    options: [
      { text: "Star maps & galaxy clusters", type: "spaceExplorer" },
      { text: "New prototype schematics", type: "inventor" },
      { text: "Game map with hidden secrets", type: "gamer" },
      { text: "Evidence mind-map with lines", type: "detective" }
    ]
  },
  {
    id: 7,
    question: "What's your ideal training routine?",
    options: [
      { text: "High-intensity physical drills", type: "sportsStar" },
      { text: "Speedrunning levels & mechanics", type: "gamer" },
      { text: "Simulating zero-G flight tests", type: "spaceExplorer" },
      { text: "Tinkering in the workshop lab", type: "inventor" }
    ]
  },
  {
    id: 8,
    question: "Faced with an opponent's defense, you:",
    options: [
      { text: "Outmaneuver with rapid footwork", type: "sportsStar" },
      { text: "Find hidden weakness in timing", type: "detective" },
      { text: "Use meta strategy & counter-picks", type: "gamer" },
      { text: "Craft custom counter-equipment", type: "inventor" }
    ]
  },
  {
    id: 9,
    question: "What drives your motivation?",
    options: [
      { text: "Conquering unknown horizons", type: "spaceExplorer" },
      { text: "Uncovering the hidden truth", type: "detective" },
      { text: "Reaching the absolute top rank", type: "gamer" },
      { text: "Creating something brand new", type: "inventor" }
    ]
  },
  {
    id: 10,
    question: "You find a mysterious ancient artifact. First action?",
    options: [
      { text: "Analyze metal & circuit composition", type: "inventor" },
      { text: "Deduce its origin from markings", type: "detective" },
      { text: "Test if it boosts your stats/power", type: "gamer" },
      { text: "Catalog it for galactic research", type: "spaceExplorer" }
    ]
  },
  {
    id: 11,
    question: "Your favorite movie genre?",
    options: [
      { text: "Deep space survival sci-fi", type: "spaceExplorer" },
      { text: "Fast-paced sports drama", type: "sportsStar" },
      { text: "Mind-bending detective mystery", type: "detective" },
      { text: "Cyberpunk tech action", type: "inventor" }
    ]
  },
  {
    id: 12,
    question: "When starting a brand-new task, you:",
    options: [
      { text: "Jump in and improvise fast", type: "sportsStar" },
      { text: "Read wiki & optimize build first", type: "gamer" },
      { text: "Investigate all background facts", type: "detective" },
      { text: "Build automated setup template", type: "inventor" }
    ]
  },
  {
    id: 13,
    question: "Pick a ideal vehicle:",
    options: [
      { text: "Supersonic space shuttle", type: "spaceExplorer" },
      { text: "High-performance sports car", type: "sportsStar" },
      { text: "Custom automated solar drone", type: "inventor" },
      { text: "Stealth intelligence surveillance van", type: "detective" }
    ]
  },
  {
    id: 14,
    question: "How do you view failure?",
    options: [
      { text: "Fuel to train harder tomorrow", type: "sportsStar" },
      { text: "A missing clue to re-examine", type: "detective" },
      { text: "A wipe that provides experience points", type: "gamer" },
      { text: "Data to refine prototype v2.0", type: "inventor" }
    ]
  },
  {
    id: 15,
    question: "You're trapped in a maze. Strategy?",
    options: [
      { text: "Sprint test paths at top speed", type: "sportsStar" },
      { text: "Follow wall logic systematically", type: "detective" },
      { text: "Jetpack straight over the walls", type: "inventor" },
      { text: "Use mini-map memory cues", type: "gamer" }
    ]
  },
  {
    id: 16,
    question: "What's on your desk right now?",
    options: [
      { text: "Smartwatches & health trackers", type: "sportsStar" },
      { text: "Star maps & telescope optics", type: "spaceExplorer" },
      { text: "Magnifying lens & notebooks", type: "detective" },
      { text: "Soldering iron & microcontrollers", type: "inventor" }
    ]
  },
  {
    id: 17,
    question: "Pick your ideal superpower:",
    options: [
      { text: "Lightspeed physical agility", type: "sportsStar" },
      { text: "Instant warp teleportation", type: "spaceExplorer" },
      { text: "Mind reading & truth sight", type: "detective" },
      { text: "Instant matter creation", type: "inventor" }
    ]
  },
  {
    id: 18,
    question: "How do you spend a rainy Sunday?",
    options: [
      { text: "Grinding ranking leaderboards", type: "gamer" },
      { text: "Reading real-crime cases", type: "detective" },
      { text: "Tinkering with DIY hardware", type: "inventor" },
      { text: "Indoors agility & gym session", type: "sportsStar" }
    ]
  },
  {
    id: 19,
    question: "You discover a strange signal. What next?",
    options: [
      { text: "Trace spatial origin point", type: "spaceExplorer" },
      { text: "Decode encrypted binary message", type: "detective" },
      { text: "Build signal booster antenna", type: "inventor" },
      { text: "Sync signal frequencies to game HUD", type: "gamer" }
    ]
  },
  {
    id: 20,
    question: "Your primary strategy in games?",
    options: [
      { text: "Aggressive fast offense play", type: "sportsStar" },
      { text: "Out-smarting enemy movement tactics", type: "gamer" },
      { text: "Uncovering all map fog-of-war", type: "spaceExplorer" },
      { text: "Crafting legendary tier gear", type: "inventor" }
    ]
  },
  {
    id: 21,
    question: "What type of challenge excites you most?",
    options: [
      { text: "High-stakes timed physical match", type: "sportsStar" },
      { text: "Uncharted deep space voyage", type: "spaceExplorer" },
      { text: "Unraveling a complex mystery", type: "detective" },
      { text: "Designing a world-changing device", type: "inventor" }
    ]
  },
  {
    id: 22,
    question: "When evaluating a new gadget, you check:",
    options: [
      { text: "FPS performance & response time", type: "gamer" },
      { text: "Durability & athletic ergonomics", type: "sportsStar" },
      { text: "Custom modding potential", type: "inventor" },
      { text: "Security features & data logs", type: "detective" }
    ]
  },
  {
    id: 23,
    question: "You have 10 free minutes. You choose to:",
    options: [
      { text: "Do rapid stretches or pushups", type: "sportsStar" },
      { text: "Play a quick strategy round", type: "gamer" },
      { text: "Sketch a quick blueprint draft", type: "inventor" },
      { text: "Observe people & spot detail patterns", type: "detective" }
    ]
  },
  {
    id: 24,
    question: "How do you prefer to learn?",
    options: [
      { text: "Muscle memory & active drills", type: "sportsStar" },
      { text: "Direct exploration & trial", type: "spaceExplorer" },
      { text: "Analyzing evidence step-by-step", type: "detective" },
      { text: "Building a practical prototype", type: "inventor" }
    ]
  },
  {
    id: 25,
    question: "Select your favorite tool:",
    options: [
      { text: "3D printer & laser cutter", type: "inventor" },
      { text: "High-magnification microscope", type: "detective" },
      { text: "Pro athletic performance gear", type: "sportsStar" },
      { text: "Long-range satellite radar", type: "spaceExplorer" }
    ]
  },
  {
    id: 26,
    question: "Faced with a rival team, your approach is:",
    options: [
      { text: "Outrun them with sheer speed", type: "sportsStar" },
      { text: "Exploit their mechanical flaws", type: "gamer" },
      { text: "Study their match video history", type: "detective" },
      { text: "Deploy surprising new tactics", type: "inventor" }
    ]
  },
  {
    id: 27,
    question: "What is your main weakness?",
    options: [
      { text: "Impatient when sitting still", type: "sportsStar" },
      { text: "Always looking beyond the present", type: "spaceExplorer" },
      { text: "Over-analyzing small clues", type: "detective" },
      { text: "Constantly redesigning finished work", type: "inventor" }
    ]
  },
  {
    id: 28,
    question: "Your ideal workspace atmosphere:",
    options: [
      { text: "High energy sports arena", type: "sportsStar" },
      { text: "Futuristic spaceship cockpit", type: "spaceExplorer" },
      { text: "Quiet lab with puzzle wall", type: "detective" },
      { text: "Maker garage full of components", type: "inventor" }
    ]
  },
  {
    id: 29,
    question: "How do you approach a locked drawer?",
    options: [
      { text: "Kick it open with power", type: "sportsStar" },
      { text: "Look for key hidden on top shelf", type: "detective" },
      { text: "Build a lock-pick mechanism", type: "inventor" },
      { text: "Find keycard item in inventory", type: "gamer" }
    ]
  },
  {
    id: 30,
    question: "Which subject sounds most interesting?",
    options: [
      { text: "Astrophysics & Exoplanets", type: "spaceExplorer" },
      { text: "Forensic Fingerprint Analysis", type: "detective" },
      { text: "Kinesiology & Athletic Peak Performance", type: "sportsStar" },
      { text: "Robotics & Embedded Hardware", type: "inventor" }
    ]
  },
  {
    id: 31,
    question: "You see a dark cave entrance. What do you do?",
    options: [
      { text: "Step inside to map uncharted depth", type: "spaceExplorer" },
      { text: "Scan ground for footprints first", type: "detective" },
      { text: "Craft custom night-vision goggles", type: "inventor" },
      { text: "Check mini-map for quest marker", type: "gamer" }
    ]
  },
  {
    id: 32,
    question: "How do you optimize your morning routine?",
    options: [
      { text: "Fast cardio workout session", type: "sportsStar" },
      { text: "Quick inventory & task daily quest", type: "gamer" },
      { text: "Automate coffee & setup triggers", type: "inventor" },
      { text: "Review schedules for anomalies", type: "detective" }
    ]
  },
  {
    id: 33,
    question: "Pick a team role:",
    options: [
      { text: "Lead striker/scorer", type: "sportsStar" },
      { text: "Tactical strategist / Shot-caller", type: "gamer" },
      { text: "Lead investigative analyst", type: "detective" },
      { text: "Chief engineer / Architect", type: "inventor" }
    ]
  },
  {
    id: 34,
    question: "What's your reaction to breaking a record?",
    options: [
      { text: "Celebrate & set a harder goal!", type: "sportsStar" },
      { text: "Log metrics for research data", type: "spaceExplorer" },
      { text: "Deduce what factors enabled it", type: "detective" },
      { text: "Build better system to break it again", type: "inventor" }
    ]
  },
  {
    id: 35,
    question: "When playing chess, your focus is:",
    options: [
      { text: "Aggressive rapid piece development", type: "sportsStar" },
      { text: "Predicting opponent's hidden intent", type: "detective" },
      { text: "Executing high-level opening meta", type: "gamer" },
      { text: "Inventing unconventional gambits", type: "inventor" }
    ]
  },
  {
    id: 36,
    question: "If you found a stray dog, you'd check for:",
    options: [
      { text: "Microchip or ID collar clues", type: "detective" },
      { text: "Overall agility & stamina", type: "sportsStar" },
      { text: "Custom tracker collar attachment", type: "inventor" },
      { text: "Cosmetic breed traits", type: "gamer" }
    ]
  },
  {
    id: 37,
    question: "What defines success for you?",
    options: [
      { text: "Victory trophy & personal best", type: "sportsStar" },
      { text: "Reaching the outer perimeter", type: "spaceExplorer" },
      { text: "Solving the mystery accurately", type: "detective" },
      { text: "Launching a fully working product", type: "inventor" }
    ]
  },
  {
    id: 38,
    question: "Which weapon/gear style do you prefer?",
    options: [
      { text: "Lightweight mobility & speed gear", type: "sportsStar" },
      { text: "Precision sniper scope / scanner", type: "detective" },
      { text: "High-tech plasma beam cannon", type: "inventor" },
      { text: "Balanced stat endgame legendary set", type: "gamer" }
    ]
  },
  {
    id: 39,
    question: "Faced with a puzzle lock, you:",
    options: [
      { text: "Deduce cipher pattern logic", type: "detective" },
      { text: "Try fast mechanical speed-runs", type: "sportsStar" },
      { text: "Hotwire electrical control circuit", type: "inventor" },
      { text: "Look up speedrun walkthrough guide", type: "gamer" }
    ]
  },
  {
    id: 40,
    question: "What's your dream vacation?",
    options: [
      { text: "Sub-orbital space tourist flight", type: "spaceExplorer" },
      { text: "Extreme sports adventure trip", type: "sportsStar" },
      { text: "Exploring historical mystery ruins", type: "detective" },
      { text: "Tech expo & robotics convention", type: "inventor" }
    ]
  },
  {
    id: 41,
    question: "How do you inspect a crime scene?",
    options: [
      { text: "Scan for bloodstains & fibers", type: "detective" },
      { text: "Search perimeter for escape route speed", type: "sportsStar" },
      { text: "Deploy autonomous scanning drones", type: "inventor" },
      { text: "Check for interactive highlight items", type: "gamer" }
    ]
  },
  {
    id: 42,
    question: "Pick your favorite element:",
    options: [
      { text: "Plasma / Zero-G Energy", type: "spaceExplorer" },
      { text: "Kinetic Power", type: "sportsStar" },
      { text: "Silicon / Electricity", type: "inventor" },
      { text: "Shadow / Invisibility", type: "detective" }
    ]
  },
  {
    id: 43,
    question: "When taking photos, you focus on:",
    options: [
      { text: "Fast dynamic motion shots", type: "sportsStar" },
      { text: "Distant starscapes & horizons", type: "spaceExplorer" },
      { text: "Hidden subtle details in shadows", type: "detective" },
      { text: "Custom macro gear lighting setups", type: "inventor" }
    ]
  },
  {
    id: 44,
    question: "Your favorite type of mobile app:",
    options: [
      { text: "Fitness tracker & stopwatch", type: "sportsStar" },
      { text: "Competitive multiplayer strategy", type: "gamer" },
      { text: "Astronomy constellation guide", type: "spaceExplorer" },
      { text: "Custom code compiler & terminal", type: "inventor" }
    ]
  },
  {
    id: 45,
    question: "How do you handle a sudden surprise?",
    options: [
      { text: "Instant lightning reflex counter", type: "sportsStar" },
      { text: "Analyze cause before acting", type: "detective" },
      { text: "Trigger defensive shield tool", type: "inventor" },
      { text: "Dodge roll & reset distance", type: "gamer" }
    ]
  },
  {
    id: 46,
    question: "What kind of book would you write?",
    options: [
      { text: "Guide to Peak Physical Conditioning", type: "sportsStar" },
      { text: "Voyages to Deep Outer Space", type: "spaceExplorer" },
      { text: "True Criminal Case Deductions", type: "detective" },
      { text: "Blueprints for Next-Gen Gadgets", type: "inventor" }
    ]
  },
  {
    id: 47,
    question: "You see a broken machine. Action?",
    options: [
      { text: "Dismantle & redesign mechanics", type: "inventor" },
      { text: "Diagnose component failure cause", type: "detective" },
      { text: "Push buttons fast to test response", type: "sportsStar" },
      { text: "Check if repair item is in inventory", type: "gamer" }
    ]
  },
  {
    id: 48,
    question: "Which target sound inspires you most?",
    options: [
      { text: "Crowd cheering in stadium", type: "sportsStar" },
      { text: "Space rocket thruster ignition", type: "spaceExplorer" },
      { text: "Level-up victory chime", type: "gamer" },
      { text: "Satisfying snap of custom 3D build", type: "inventor" }
    ]
  },
  {
    id: 49,
    question: "How do you approach a big match/event?",
    options: [
      { text: "Warm up muscles & get hyped", type: "sportsStar" },
      { text: "Review opponent stats & replay footage", type: "detective" },
      { text: "Equip optimized gear layout", type: "gamer" },
      { text: "Prepare custom tactical tools", type: "inventor" }
    ]
  },
  {
    id: 50,
    question: "What's your primary goal in a new city?",
    options: [
      { text: "Find the best local sports field", type: "sportsStar" },
      { text: "Explore uncharted backstreets", type: "spaceExplorer" },
      { text: "Investigate local legends & history", type: "detective" },
      { text: "Visit local maker spaces & workshops", type: "inventor" }
    ]
  },
  {
    id: 51,
    question: "You get a blank canvas. What do you create?",
    options: [
      { text: "High-speed action painting", type: "sportsStar" },
      { text: "Interactive LED light board", type: "inventor" },
      { text: "Deep cosmic nebula landscape", type: "spaceExplorer" },
      { text: "Hidden message optical illusion", type: "detective" }
    ]
  },
  {
    id: 52,
    question: "Your favorite board game type:",
    options: [
      { text: "Real-time fast reaction games", type: "sportsStar" },
      { text: "Social deduction & mystery games", type: "detective" },
      { text: "Resource management strategy", type: "gamer" },
      { text: "Tile-building construction games", type: "inventor" }
    ]
  },
  {
    id: 53,
    question: "When encountering an unfamiliar word, you:",
    options: [
      { text: "Look up origin & root clues", type: "detective" },
      { text: "Search context across web docs", type: "spaceExplorer" },
      { text: "Add it to personal custom glossary app", type: "inventor" },
      { text: "Guess meaning & keep moving fast", type: "sportsStar" }
    ]
  },
  {
    id: 54,
    question: "Pick your ideal wearable device:",
    options: [
      { text: "Biometric heart & speed monitor", type: "sportsStar" },
      { text: "Smart AR glasses with HUD overlay", type: "gamer" },
      { text: "Satellite location emergency beacon", type: "spaceExplorer" },
      { text: "Programmable wrist computer", type: "inventor" }
    ]
  },
  {
    id: 55,
    question: "How do you handle a slow computer?",
    options: [
      { text: "Close background app bloat", type: "gamer" },
      { text: "Overclock CPU & add custom cooling", type: "inventor" },
      { text: "Audit system log files for bugs", type: "detective" },
      { text: "Swap for a faster modern rig", type: "sportsStar" }
    ]
  },
  {
    id: 56,
    question: "What's your focus during a team talk?",
    options: [
      { text: "Pumping up physical morale & energy", type: "sportsStar" },
      { text: "Pointing out opponent weaknesses", type: "detective" },
      { text: "Assigning tactical roles & combos", type: "gamer" },
      { text: "Proposing automated workflow tools", type: "inventor" }
    ]
  },
  {
    id: 57,
    question: "You see a strange footprint on the trail. You:",
    options: [
      { text: "Measure depth & stride distance", type: "detective" },
      { text: "Track it into the unknown forest", type: "spaceExplorer" },
      { text: "Cast 3D print replica of print", type: "inventor" },
      { text: "Sprint ahead to catch up to it", type: "sportsStar" }
    ]
  },
  {
    id: 58,
    question: "What kind of video edits do you like?",
    options: [
      { text: "High-intensity sports highlights", type: "sportsStar" },
      { text: "Cinematic space exploration visuals", type: "spaceExplorer" },
      { text: "Gaming montage with fast syncs", type: "gamer" },
      { text: "VFX tech build demonstrations", type: "inventor" }
    ]
  },
  {
    id: 59,
    question: "How do you rate a successful project?",
    options: [
      { text: "Flawless execution under pressure", type: "sportsStar" },
      { text: "Zero unsolved issues or bugs", type: "detective" },
      { text: "Original creation built from scratch", type: "inventor" },
      { text: "Hit highest score leaderboard rank", type: "gamer" }
    ]
  },
  {
    id: 60,
    question: "Pick an outdoor activity:",
    options: [
      { text: "Mountain trail sprint racing", type: "sportsStar" },
      { text: "Stargazing with telescope", type: "spaceExplorer" },
      { text: "Geocaching treasure hunting", type: "detective" },
      { text: "Flying custom-built drones", type: "inventor" }
    ]
  },
  {
    id: 61,
    question: "When lost in a city, you first:",
    options: [
      { text: "Deduce cardinal direction from sun", type: "detective" },
      { text: "Wander around to discover new spots", type: "spaceExplorer" },
      { text: "Build custom offline GPS map script", type: "inventor" },
      { text: "Run toward central landmark tower", type: "sportsStar" }
    ]
  },
  {
    id: 62,
    question: "What's your stance on rules?",
    options: [
      { text: "Push boundaries within game limits", type: "sportsStar" },
      { text: "Exploit loophole mechanics to win", type: "gamer" },
      { text: "Analyze why rule was created first", type: "detective" },
      { text: "Rewrite rules with new systems", type: "inventor" }
    ]
  },
  {
    id: 63,
    question: "Pick a legendary historical figure:",
    options: [
      { text: "Muhammad Ali - athletic icon", type: "sportsStar" },
      { text: "Neil Armstrong - moon pioneer", type: "spaceExplorer" },
      { text: "Sherlock Holmes - master detective", type: "detective" },
      { text: "Nikola Tesla - prolific inventor", type: "inventor" }
    ]
  },
  {
    id: 64,
    question: "How do you choose a restaurant?",
    options: [
      { text: "High-protein athletic meal choices", type: "sportsStar" },
      { text: "Unusual exotic cuisine you never tried", type: "spaceExplorer" },
      { text: "Inspect health audit & review records", type: "detective" },
      { text: "Automated robotic kitchen spots", type: "inventor" }
    ]
  },
  {
    id: 65,
    question: "Your favorite gaming gear item:",
    options: [
      { text: "Ultra-low latency sports mouse", type: "sportsStar" },
      { text: "Custom macro mechanical keyboard", type: "inventor" },
      { text: "Immersive VR spatial headset", type: "spaceExplorer" },
      { text: "High-tier noise canceling headset", type: "detective" }
    ]
  },
  {
    id: 66,
    question: "What is your reaction to a challenge?",
    options: [
      { text: "Game on! Bring it!", type: "sportsStar" },
      { text: "Time to uncover the facts.", type: "detective" },
      { text: "Let's build a solution.", type: "inventor" },
      { text: "A new quest! Let's grind.", type: "gamer" }
    ]
  },
  {
    id: 67,
    question: "Which science subject appeals to you most?",
    options: [
      { text: "Astrophysics", type: "spaceExplorer" },
      { text: "Forensic Toxicology", type: "detective" },
      { text: "Biomechanics", type: "sportsStar" },
      { text: "Electrical Engineering", type: "inventor" }
    ]
  },
  {
    id: 68,
    question: "How do you organize your physical room?",
    options: [
      { text: "Minimal space for workout movements", type: "sportsStar" },
      { text: "Evidence board with connected strings", type: "detective" },
      { text: "Workbenches full of tools & parts", type: "inventor" },
      { text: "Dual-monitor RGB battlestation", type: "gamer" }
    ]
  },
  {
    id: 69,
    question: "You hear an unexpected noise outside at night. First thought?",
    options: [
      { text: "Investigate footprints near window", type: "detective" },
      { text: "React fast & move to inspect", type: "sportsStar" },
      { text: "Check automated motion sensors", type: "inventor" },
      { text: "Check outdoor security radar", type: "spaceExplorer" }
    ]
  },
  {
    id: 70,
    question: "Pick your ideal pet animal:",
    options: [
      { text: "Fast Greyhound race dog", type: "sportsStar" },
      { text: "Observant Bloodhound tracker", type: "detective" },
      { text: "Robotic AI companion dog", type: "inventor" },
      { text: "Falcon that surveys from sky", type: "spaceExplorer" }
    ]
  },
  {
    id: 71,
    question: "What's your primary strategy in a simulation game?",
    options: [
      { text: "Expand territory frontiers fast", type: "spaceExplorer" },
      { text: "Optimize resource collection efficiency", type: "gamer" },
      { text: "Build custom automated machinery", type: "inventor" },
      { text: "Spot economic bugs & market flaws", type: "detective" }
    ]
  },
  {
    id: 72,
    question: "How do you approach learning code?",
    options: [
      { text: "Build a working app project right away", type: "inventor" },
      { text: "Debug existing code to learn mechanics", type: "detective" },
      { text: "Practice daily algorithm speed challenges", type: "sportsStar" },
      { text: "Follow game dev tutorial series", type: "gamer" }
    ]
  },
  {
    id: 73,
    question: "Select your favorite gadget component:",
    options: [
      { text: "Microcontroller board (Raspberry Pi)", type: "inventor" },
      { text: "High-sensitivity audio bug listener", type: "detective" },
      { text: "Sub-millisecond reaction switch", type: "sportsStar" },
      { text: "Solar array power collector", type: "spaceExplorer" }
    ]
  },
  {
    id: 74,
    question: "What kind of podcasts do you listen to?",
    options: [
      { text: "Athlete training & mindset stories", type: "sportsStar" },
      { text: "Unsolved cold-case investigations", type: "detective" },
      { text: "DIY electronics & future tech", type: "inventor" },
      { text: "Deep space missions & astronomy", type: "spaceExplorer" }
    ]
  },
  {
    id: 75,
    question: "Faced with a complex puzzle, you:",
    options: [
      { text: "Look for logic contradictions", type: "detective" },
      { text: "Test speed trial combinations", type: "sportsStar" },
      { text: "Write solver algorithm script", type: "inventor" },
      { text: "Recognize familiar game puzzle archetype", type: "gamer" }
    ]
  },
  {
    id: 76,
    question: "How do you react to a tough loss?",
    options: [
      { text: "Hit the gym to bounce back stronger", type: "sportsStar" },
      { text: "Review replay to find specific misplay", type: "gamer" },
      { text: "Analyze evidence of what went wrong", type: "detective" },
      { text: "Build a new tool to prevent error", type: "inventor" }
    ]
  },
  {
    id: 77,
    question: "Pick an ideal workspace location:",
    options: [
      { text: "High-tech satellite ground station", type: "spaceExplorer" },
      { text: "Private investigation office", type: "detective" },
      { text: "Robotics hardware lab", type: "inventor" },
      { text: "Training facility manager desk", type: "sportsStar" }
    ]
  },
  {
    id: 78,
    question: "What's your approach when buying a device?",
    options: [
      { text: "Check benchmark speed specs", type: "gamer" },
      { text: "Inspect durability for outdoor conditions", type: "sportsStar" },
      { text: "Ensure full hardware customizability", type: "inventor" },
      { text: "Verify security & privacy policies", type: "detective" }
    ]
  },
  {
    id: 79,
    question: "Which environment draws you in?",
    options: [
      { text: "Deep underwater oceanic trenches", type: "spaceExplorer" },
      { text: "Futuristic neon cyberpunk alleyways", type: "gamer" },
      { text: "Packed competitive stadium grounds", type: "sportsStar" },
      { text: "Quiet archival room with old files", type: "detective" }
    ]
  },
  {
    id: 80,
    question: "How do you track your daily goals?",
    options: [
      { text: "Fitness watch activity rings", type: "sportsStar" },
      { text: "Daily quest checklists & XP points", type: "gamer" },
      { text: "Automated custom spreadsheet dashboard", type: "inventor" },
      { text: "Case progress logbook entries", type: "detective" }
    ]
  },
  {
    id: 81,
    question: "What do you do with old broken electronics?",
    options: [
      { text: "Harvest parts for future projects", type: "inventor" },
      { text: "Inspect component to find why it failed", type: "detective" },
      { text: "Toss them out to keep space minimal", type: "sportsStar" },
      { text: "Attempt to mod or soft-brick jailbreak", type: "gamer" }
    ]
  },
  {
    id: 82,
    question: "Select a favorite movie trope:",
    options: [
      { text: "Underdog team winning at last second", type: "sportsStar" },
      { text: "Brilliant detective revealing killer", type: "detective" },
      { text: "Pioneer entering uncharted wormhole", type: "spaceExplorer" },
      { text: "Inventor crafting device in garage montage", type: "inventor" }
    ]
  },
  {
    id: 83,
    question: "Your approach when cooking meals:",
    options: [
      { text: "High-energy fast prep nutrition", type: "sportsStar" },
      { text: "Experiment with molecular gastronomy tools", type: "inventor" },
      { text: "Precision taste testing to balance flavor", type: "detective" },
      { text: "Following precise step-by-step recipe craft", type: "gamer" }
    ]
  },
  {
    id: 84,
    question: "What type of map do you like best?",
    options: [
      { text: "Star chart constellation maps", type: "spaceExplorer" },
      { text: "Topology terrain elevation maps", type: "sportsStar" },
      { text: "Crime frequency heatmap analysis", type: "detective" },
      { text: "Video game world map with fog of war", type: "gamer" }
    ]
  },
  {
    id: 85,
    question: "When presented with a choice, you rely on:",
    options: [
      { text: "Instinctive rapid gut reaction", type: "sportsStar" },
      { text: "Hard evidence & proven facts", type: "detective" },
      { text: "Calculated risk probabilities", type: "gamer" },
      { text: "Testing both through quick experiments", type: "inventor" }
    ]
  },
  {
    id: 86,
    question: "Which accessory would you wear daily?",
    options: [
      { text: "Performance sweatband / athletic gear", type: "sportsStar" },
      { text: "Smart badge with programmable microchip", type: "inventor" },
      { text: "Compact magnifying pocket loupe", type: "detective" },
      { text: "Constellation compass pendant", type: "spaceExplorer" }
    ]
  },
  {
    id: 87,
    question: "How do you handle team disagreements?",
    options: [
      { text: "Rally energy towards immediate action", type: "sportsStar" },
      { text: "Examine facts neutrally to find truth", type: "detective" },
      { text: "Propose a quick hybrid solution prototype", type: "inventor" },
      { text: "Vote based on clear efficiency metrics", type: "gamer" }
    ]
  },
  {
    id: 88,
    question: "Pick your ideal weekend project:",
    options: [
      { text: "Building a home-automation IoT sensor", type: "inventor" },
      { text: "Training for an upcoming 10k run", type: "sportsStar" },
      { text: "Solving a murder-mystery game box", type: "detective" },
      { text: "Camping under dark skies to spot meteors", type: "spaceExplorer" }
    ]
  },
  {
    id: 89,
    question: "What's your stance on taking risks?",
    options: [
      { text: "Essential for athletic victory", type: "sportsStar" },
      { text: "Necessary when charting unknown frontier", type: "spaceExplorer" },
      { text: "Only take risks supported by clear facts", type: "detective" },
      { text: "Risk is fine if you build a safety mechanism", type: "inventor" }
    ]
  },
  {
    id: 90,
    question: "What kind of desktop wallpaper do you use?",
    options: [
      { text: "High-res James Webb Space Telescope photo", type: "spaceExplorer" },
      { text: "Clean dark grid with minimal distraction", type: "detective" },
      { text: "Blueprint circuit layout art", type: "inventor" },
      { text: "Custom concept art from favorite game", type: "gamer" }
    ]
  },
  {
    id: 91,
    question: "How do you view time management?",
    options: [
      { text: "Every second counts in the match", type: "sportsStar" },
      { text: "Timebox tasks like game daily quests", type: "gamer" },
      { text: "Chronological timelines reveal key facts", type: "detective" },
      { text: "Automate repetitive tasks to save time", type: "inventor" }
    ]
  },
  {
    id: 92,
    question: "If you found a locked safe, first move?",
    options: [
      { text: "Listen to tumbler clicks to crack combo", type: "detective" },
      { text: "Attach automated dialer machine", type: "inventor" },
      { text: "Look up default factory reset codes", type: "gamer" },
      { text: "Try physical force leverage", type: "sportsStar" }
    ]
  },
  {
    id: 93,
    question: "Select your favorite store section:",
    options: [
      { text: "Sports & Athletic Gear", type: "sportsStar" },
      { text: "Electronics & DIY Hardware", type: "inventor" },
      { text: "Telescopes & Outdoor Survival", type: "spaceExplorer" },
      { text: "Puzzles & Logic Books", type: "detective" }
    ]
  },
  {
    id: 94,
    question: "What drives your interest in AI?",
    options: [
      { text: "Building autonomous smart devices", type: "inventor" },
      { text: "Using AI to analyze complex pattern data", type: "detective" },
      { text: "AI NPC behavior in game worlds", type: "gamer" },
      { text: "AI trajectory planning for space probes", type: "spaceExplorer" }
    ]
  },
  {
    id: 95,
    question: "How do you approach a long journey?",
    options: [
      { text: "Focus on speed and endurance performance", type: "sportsStar" },
      { text: "Embrace the journey into unknown land", type: "spaceExplorer" },
      { text: "Keep a detailed journal of observations", type: "detective" },
      { text: "Bring custom portable power & modded gear", type: "inventor" }
    ]
  },
  {
    id: 96,
    question: "Which badge would you wear with pride?",
    options: [
      { text: "Champion Trophy Medal", type: "sportsStar" },
      { text: "Galactic Explorer Patch", type: "spaceExplorer" },
      { text: "Master Investigator Insignia", type: "detective" },
      { text: "Patent Creator Seal", type: "inventor" }
    ]
  },
  {
    id: 97,
    question: "How do you react when a plan changes?",
    options: [
      { text: "Pivot instantly and sprint in new direction", type: "sportsStar" },
      { text: "Investigate why change occurred", type: "detective" },
      { text: "Build quick temporary workaround tool", type: "inventor" },
      { text: "Adapt tactical build on the fly", type: "gamer" }
    ]
  },
  {
    id: 98,
    question: "What's your favorite puzzle style?",
    options: [
      { text: "Physical speed-cube solving", type: "sportsStar" },
      { text: "Deductive logic grid puzzles", type: "detective" },
      { text: "Mechanical wooden assembly puzzles", type: "inventor" },
      { text: "Spatial 3D maze puzzles", type: "gamer" }
    ]
  },
  {
    id: 99,
    question: "Pick your core personal philosophy:",
    options: [
      { text: "Faster, Higher, Stronger.", type: "sportsStar" },
      { text: "To boldy go where none have gone.", type: "spaceExplorer" },
      { text: "The truth is hidden in the details.", type: "detective" },
      { text: "If it doesn't exist yet, build it.", type: "inventor" }
    ]
  },
  {
    id: 100,
    question: "How do you end a productive day?",
    options: [
      { text: "Cool down session & physical recovery", type: "sportsStar" },
      { text: "Log new star/land discoveries", type: "spaceExplorer" },
      { text: "Review case notes & cross off facts", type: "detective" },
      { text: "Commit working code & power down lab", type: "inventor" }
    ]
  }, 
  {
    id: 101,
    question: "A high-stakes countdown reaches 0:03 seconds. Your immediate move?",
    options: [
      { text: "Sprint in for a buzzer-beater play", type: "sportsStar" },
      { text: "Cut the wire after rapid circuit analysis", type: "inventor" },
      { text: "Deduce the real decoy wire using logic", type: "detective" },
      { text: "Hit your invincibility frame dodge roll", type: "gamer" }
    ]
  },
  {
    id: 102,
    question: "You get access to a top-secret futuristic lab. What do you check first?",
    options: [
      { text: "The experimental warp drive engine", type: "spaceExplorer" },
      { text: "The 3D atomic device synthesizer", type: "inventor" },
      { text: "The classified investigation case files", type: "detective" },
      { text: "The full-immersion neural haptic rig", type: "gamer" }
    ]
  },
  {
    id: 103,
    question: "What's your preferred way to win a intense showdown?",
    options: [
      { text: "Out-endure your rival with sheer hustle", type: "sportsStar" },
      { text: "Expose their hidden pattern vulnerability", type: "detective" },
      { text: "Out-calculate them with custom tech gear", type: "inventor" },
      { text: "Execute a flawless frame-perfect combo", type: "gamer" }
    ]
  },
  {
    id: 104,
    question: "You stumble across a glowing alien egg on a mission. Reaction?",
    options: [
      { text: "Document coordinates & atmospheric conditions", type: "spaceExplorer" },
      { text: "Analyze bio-energy thermal signatures", type: "inventor" },
      { text: "Scan surroundings for parent creature tracks", type: "detective" },
      { text: "Prepare for a legendary boss encounter", type: "gamer" }
    ]
  },
  {
    id: 105,
    question: "Your team is losing hard in the second half. How do you flip it?",
    options: [
      { text: "Rally energy & increase physical tempo", type: "sportsStar" },
      { text: "Shift to a counter-meta emergency build", type: "gamer" },
      { text: "Spot the opponent's strategy pattern flaw", type: "detective" },
      { text: "Introduce a wild wildcard custom play", type: "inventor" }
    ]
  },
  {
    id: 106,
    question: "Pick your primary weapon/tool for a fantasy quest:",
    options: [
      { text: "Enchanted light-speed boots & spear", type: "sportsStar" },
      { text: "Telescopic cosmic star-forged compass", type: "spaceExplorer" },
      { text: "Truth-revealing shadow glass ocular", type: "detective" },
      { text: "Self-crafting automated mechanical golem", type: "inventor" }
    ]
  },
  {
    id: 107,
    question: "How do you handle a complex mystery with zero clues?",
    options: [
      { text: "Interrogate witnesses to spot micro-reactions", type: "detective" },
      { text: "Build a forensic data analysis tool", type: "inventor" },
      { text: "Explore surrounding sectors for fresh evidence", type: "spaceExplorer" },
      { text: "Brute force every dialog branch option", type: "gamer" }
    ]
  },
  {
    id: 108,
    question: "What type of streaming content do you create?",
    options: [
      { text: "Live athletic challenges & workouts", type: "sportsStar" },
      { text: "Speedrunning games & meta breakdowns", type: "gamer" },
      { text: "True crime investigations & breakdown", type: "detective" },
      { text: "Hardware teardowns & DIY builds", type: "inventor" }
    ]
  },
  {
    id: 109,
    question: "You find a mysterious sealed vault in an abandoned city:",
    options: [
      { text: "Chart the uncharted underground layout", type: "spaceExplorer" },
      { text: "Hack the electronic locking mechanism", type: "inventor" },
      { text: "Deduce the combination from wall clues", type: "detective" },
      { text: "Look for high-tier loot chest glows", type: "gamer" }
    ]
  },
  {
    id: 110,
    question: "What's your ultimate flex?",
    options: [
      { text: "Winning a gold championship medal", type: "sportsStar" },
      { text: "Being first human to land on Mars", type: "spaceExplorer" },
      { text: "Solving a 20-year-old cold case", type: "detective" },
      { text: "Patenting a revolutionary invention", type: "inventor" }
    ]
  },
  {
    id: 111,
    question: "How do you handle an aggressive opponent talking trash?",
    options: [
      { text: "Let your performance on court speak", type: "sportsStar" },
      { text: "Analyze their insecurity & counter quiet", type: "detective" },
      { text: "Out-play them in a 1v1 matchup", type: "gamer" },
      { text: "Ignore noise & tweak your setup", type: "inventor" }
    ]
  },
  {
    id: 112,
    question: "You are stuck in zero gravity. First thing you do?",
    options: [
      { text: "Do backflips & test body mobility", type: "sportsStar" },
      { text: "Look out window at planet curvature", type: "spaceExplorer" },
      { text: "Test microgravity thruster gear", type: "inventor" },
      { text: "Check your drift trajectory status HUD", type: "gamer" }
    ]
  },
  {
    id: 113,
    question: "Pick an ideal sidekick for your adventures:",
    options: [
      { text: "Lightning-fast tracking canine", type: "detective" },
      { text: "Autonomous flying drone assistant", type: "inventor" },
      { text: "Feisty rival athlete training partner", type: "sportsStar" },
      { text: "High-stat max level support companion", type: "gamer" }
    ]
  },
  {
    id: 114,
    question: "What draws you to an action movie?",
    options: [
      { text: "Crazy realistic stunt choreography", type: "sportsStar" },
      { text: "Deep cosmic sci-fi worldbuilding", type: "spaceExplorer" },
      { text: "Twisted plot reveals & mystery arcs", type: "detective" },
      { text: "Cyberpunk tech & explosive gadgets", type: "inventor" }
    ]
  },
  {
    id: 115,
    question: "You receive a encrypted briefcase. Step one?",
    options: [
      { text: "Search exterior for fingerprint residue", type: "detective" },
      { text: "Build an ultrasonic decoder scanner", type: "inventor" },
      { text: "Force latch open with physical leverage", type: "sportsStar" },
      { text: "Search online forums for cheat cipher", type: "gamer" }
    ]
  },
  {
    id: 116,
    question: "What's your reaction when entering a huge stadium?",
    options: [
      { text: "Feel the rush of adrenaline & crowd energy!", type: "sportsStar" },
      { text: "Inspect architectural stress & structure", type: "inventor" },
      { text: "Map all exit routes & vantage points", type: "detective" },
      { text: "Estimate max spectator capacity numbers", type: "spaceExplorer" }
    ]
  },
  {
    id: 117,
    question: "You are designing your custom dream vehicle. You focus on:",
    options: [
      { text: "Top-tier horsepower & acceleration speed", type: "sportsStar" },
      { text: "Atmospheric reentry heat shields", type: "spaceExplorer" },
      { text: "Stealth matte wrap & signal jamming", type: "detective" },
      { text: "Automated AI autopilot & mod modularity", type: "inventor" }
    ]
  },
  {
    id: 118,
    question: "How do you solve a sudden budget constraint?",
    options: [
      { text: "Cut bloat & optimize resource builds", type: "gamer" },
      { text: "Audit expenses to find hidden leaks", type: "detective" },
      { text: "Build DIY low-cost alternative tools", type: "inventor" },
      { text: "Work twice as hard to out-produce", type: "sportsStar" }
    ]
  },
  {
    id: 119,
    question: "Pick your ideal escape room scenario:",
    options: [
      { text: "Haunted murder mansion mystery", type: "detective" },
      { text: "Derelict spaceship protocol reboot", type: "spaceExplorer" },
      { text: "Mad scientist high-tech laboratory", type: "inventor" },
      { text: "Ninja obstacle physical speed run", type: "sportsStar" }
    ]
  },
  {
    id: 120,
    question: "What sound triggers instant focus for you?",
    options: [
      { text: "Referee whistle starting the match", type: "sportsStar" },
      { text: "Satisfying boot sequence chime", type: "inventor" },
      { text: "Clicking mechanical lock tumbler", type: "detective" },
      { text: "Match found 'Accept' notification", type: "gamer" }
    ]
  },
  {
    id: 121,
    question: "You find an anomalous signal on radio frequencies:",
    options: [
      { text: "Map signal trajectory into outer space", type: "spaceExplorer" },
      { text: "Decipher code for secret messages", type: "detective" },
      { text: "Construct a custom receiver dish antenna", type: "inventor" },
      { text: "Sync signal frequencies to custom HUD", type: "gamer" }
    ]
  },
  {
    id: 122,
    question: "How do you rate a video game experience?",
    options: [
      { text: "Smooth 120+ FPS & tight mechanics", type: "gamer" },
      { text: "Vast immersive world to discover", type: "spaceExplorer" },
      { text: "Deep story with clever plot twists", type: "detective" },
      { text: "Deep crafting & building customization", type: "inventor" }
    ]
  },
  {
    id: 123,
    question: "What's your go-to response in an argument?",
    options: [
      { text: "Present undeniable documented evidence", type: "detective" },
      { text: "Propose a practical prototype solution", type: "inventor" },
      { text: "Out-maneuver using tactical logic", type: "gamer" },
      { text: "Challenge them to a direct match", type: "sportsStar" }
    ]
  },
  {
    id: 124,
    question: "Which setting sounds coolest for a getaway?",
    options: [
      { text: "Lunar base with Earth-view lounge", type: "spaceExplorer" },
      { text: "High-altitude Olympic training camp", type: "sportsStar" },
      { text: "Victorian manor full of secret passages", type: "detective" },
      { text: "Silicon Valley automated tech farm", type: "inventor" }
    ]
  },
  {
    id: 125,
    question: "You need to jump over a wide gap. Approach?",
    options: [
      { text: "Sprint with max speed & full leap", type: "sportsStar" },
      { text: "Deploy portable grappling gadget", type: "inventor" },
      { text: "Inspect edge landing stability first", type: "detective" },
      { text: "Execute double-jump timing window", type: "gamer" }
    ]
  },
  {
    id: 126,
    question: "What is your stance on new tech updates?",
    options: [
      { text: "Read patch notes for stat changes", type: "gamer" },
      { text: "Dissect code to find new exploits", type: "detective" },
      { text: "Integrate new API features into builds", type: "inventor" },
      { text: "Test speed performance immediately", type: "sportsStar" }
    ]
  },
  {
    id: 127,
    question: "You see a strange light in the night sky. You:",
    options: [
      { text: "Point telescope to log coordinates", type: "spaceExplorer" },
      { text: "Analyze light spectrum & flickering pattern", type: "detective" },
      { text: "Build a high-gain camera tracker", type: "inventor" },
      { text: "Film it for viral online content", type: "sportsStar" }
    ]
  },
  {
    id: 128,
    question: "What's your strategy when playing battle royale?",
    options: [
      { text: "Hot drop for immediate high-action fights", type: "sportsStar" },
      { text: "Land on map edges to loot & map zone", type: "spaceExplorer" },
      { text: "Ambush enemies by tracking footsteps", type: "detective" },
      { text: "Craft custom loadouts & trap setups", type: "inventor" }
    ]
  },
  {
    id: 129,
    question: "Pick your ideal avatar outfit style:",
    options: [
      { text: "Streamlined compression athletic wear", type: "sportsStar" },
      { text: "Sleek astronaut EVA spacesuit", type: "spaceExplorer" },
      { text: "Classic trench coat & smart glasses", type: "detective" },
      { text: "Cybernetic exo-suit with tool belt", type: "inventor" }
    ]
  },
  {
    id: 130,
    question: "What frustrates you the most?",
    options: [
      { text: "Sluggish reaction speed or lag", type: "sportsStar" },
      { text: "Unsolved mysteries left hanging", type: "detective" },
      { text: "Badly designed broken machines", type: "inventor" },
      { text: "Unexplored fog-of-war on maps", type: "spaceExplorer" }
    ]
  },
  {
    id: 131,
    question: "How do you organize your digital files?",
    options: [
      { text: "By strict evidence tags & dates", type: "detective" },
      { text: "Automated custom scripts & folder rules", type: "inventor" },
      { text: "Shortcuts for fastest launch speed", type: "sportsStar" },
      { text: "Categorized by game genre & loadouts", type: "gamer" }
    ]
  },
  {
    id: 132,
    question: "Your favorite physical activity during breaks:",
    options: [
      { text: "Fast reaction ball-catch drills", type: "sportsStar" },
      { text: "Outdoor walk while inspecting surroundings", type: "detective" },
      { text: "Tinkering with desk mechanical fidgets", type: "inventor" },
      { text: "Stretching while watching rocket launches", type: "spaceExplorer" }
    ]
  },
  {
    id: 133,
    question: "You are given 100 free microchips. What do you build?",
    options: [
      { text: "A networked smart-home array", type: "inventor" },
      { text: "A mini supercomputer cluster", type: "gamer" },
      { text: "Covert surveillance motion trackers", type: "detective" },
      { text: "CubeSat satellite payload model", type: "spaceExplorer" }
    ]
  },
  {
    id: 134,
    question: "When faced with an unexpected obstacle, you:",
    options: [
      { text: "Power through with rapid momentum", type: "sportsStar" },
      { text: "Deduce the weakest structural point", type: "detective" },
      { text: "Invent an alternative bypass tool", type: "inventor" },
      { text: "Exploit boundary physics to slip through", type: "gamer" }
    ]
  },
  {
    id: 135,
    question: "What's your dream garage setup?",
    options: [
      { text: "Full athletic gym & sprint track", type: "sportsStar" },
      { text: "CNC machines, 3D printers & lathes", type: "inventor" },
      { text: "Forensic laboratory & inspection gear", type: "detective" },
      { text: "Sim-racing rig & multi-display hub", type: "gamer" }
    ]
  },
  {
    id: 136,
    question: "Which sci-fi gadget do you wish existed today?",
    options: [
      { text: "Faster-Than-Light Space Warp Engine", type: "spaceExplorer" },
      { text: "Instant Matter Replicator / Printer", type: "inventor" },
      { text: "Universal Mind-Reading Truth Scanner", type: "detective" },
      { text: "Full-Body Haptic Neural Link VR", type: "gamer" }
    ]
  },
  {
    id: 137,
    question: "How do you react to a dramatic plot twist?",
    options: [
      { text: "Rewind scenes to spot hidden foreshadowing", type: "detective" },
      { text: "Appreciate the writer's narrative mechanics", type: "gamer" },
      { text: "Predict how technology changes the ending", type: "inventor" },
      { text: "Get hyped for the epic final showdown!", type: "sportsStar" }
    ]
  },
  {
    id: 138,
    question: "You enter a dark unknown wilderness. First priority?",
    options: [
      { text: "Chart surrounding high-ground terrain", type: "spaceExplorer" },
      { text: "Look for animal tracks & safety threats", type: "detective" },
      { text: "Build a solar-powered LED torch", type: "inventor" },
      { text: "Maintain high agility sprint posture", type: "sportsStar" }
    ]
  },
  {
    id: 139,
    question: "What is your strategy when starting a new game?",
    options: [
      { text: "Optimize controller button mapping first", type: "gamer" },
      { text: "Explore every corner of opening town", type: "spaceExplorer" },
      { text: "Test character movement speed & jumps", type: "sportsStar" },
      { text: "Analyze skill tree synergizing paths", type: "inventor" }
    ]
  },
  {
    id: 140,
    question: "Pick your favorite subject to discuss over dinner:",
    options: [
      { text: "Deep space discoveries & exoplanets", type: "spaceExplorer" },
      { text: "Famous historical unsolved crimes", type: "detective" },
      { text: "Next-gen AI hardware & robotics", type: "inventor" },
      { text: "Peak human performance & sports science", type: "sportsStar" }
    ]
  },
  {
    id: 141,
    question: "How do you test a newly assembled product?",
    options: [
      { text: "Push it to extreme stress limits", type: "sportsStar" },
      { text: "Inspect every seam for micro-defects", type: "detective" },
      { text: "Run benchmark diagnostic tests", type: "inventor" },
      { text: "Compare stats against previous model", type: "gamer" }
    ]
  },
  {
    id: 142,
    question: "You see a closed door with 'DO NOT ENTER'. You:",
    options: [
      { text: "Investigate why access is restricted", type: "detective" },
      { text: "Peer through gap to map interior space", type: "spaceExplorer" },
      { text: "Hack keycard reader circuit", type: "inventor" },
      { text: "Check if door has interaction prompt", type: "gamer" }
    ]
  },
  {
    id: 143,
    question: "What is your main priority in a zombie apocalypse?",
    options: [
      { text: "Maintain agility & run fast", type: "sportsStar" },
      { text: "Fortify shelter with automated defenses", type: "inventor" },
      { text: "Scout unknown distant safe zones", type: "spaceExplorer" },
      { text: "Deduce cause of virus outbreak origin", type: "detective" }
    ]
  },
  {
    id: 144,
    question: "Your favorite type of YouTube video to watch:",
    options: [
      { text: "Insane athletic trickshots & highlights", type: "sportsStar" },
      { text: "Space documentary universe deep dives", type: "spaceExplorer" },
      { text: "Deep-dive cold case mystery essays", type: "detective" },
      { text: "Satisfying engineering & DIY builds", type: "inventor" }
    ]
  },
  {
    id: 145,
    question: "How do you approach learning a new sport?",
    options: [
      { text: "Drill basic muscle movements repeatedly", type: "sportsStar" },
      { text: "Study professional match footage strategy", type: "detective" },
      { text: "Optimize biomechanics & footwork angles", type: "inventor" },
      { text: "Treat skill progression like leveling up", type: "gamer" }
    ]
  },
  {
    id: 146,
    question: "Pick your ideal weapon upgrade path:",
    options: [
      { text: "Increased fire rate & sprint speed", type: "sportsStar" },
      { text: "Added scope optics & thermal highlight", type: "detective" },
      { text: "Custom elemental plasma attachments", type: "inventor" },
      { text: "Maximized raw DPS output stats", type: "gamer" }
    ]
  },
  {
    id: 147,
    question: "When you hear a rumor, your reaction is:",
    options: [
      { text: "Cross-reference facts to find origin source", type: "detective" },
      { text: "Ignore talk & keep grinding your goal", type: "sportsStar" },
      { text: "Analyze behavior dynamics mathematically", type: "inventor" },
      { text: "Check community forums for verification", type: "gamer" }
    ]
  },
  {
    id: 148,
    question: "What kind of museum would you visit first?",
    options: [
      { text: "National Air and Space Museum", type: "spaceExplorer" },
      { text: "Crime & Forensic Science Museum", type: "detective" },
      { text: "Robotics & Innovation Science Center", type: "inventor" },
      { text: "Sports Hall of Fame Exhibition", type: "sportsStar" }
    ]
  },
  {
    id: 149,
    question: "You find a strange button on your computer desk:",
    options: [
      { text: "Press it fast to see immediate effect!", type: "sportsStar" },
      { text: "Trace wiring connection underneath desk", type: "detective" },
      { text: "Open device manager to monitor signal", type: "inventor" },
      { text: "Map button to a custom game macro", type: "gamer" }
    ]
  },
  {
    id: 150,
    question: "Select your core strength in group projects:",
    options: [
      { text: "Driving high energy & fast execution", type: "sportsStar" },
      { text: "Spotting errors & quality control", type: "detective" },
      { text: "Building custom templates & systems", type: "inventor" },
      { text: "Exploring uncharted creative ideas", type: "spaceExplorer" }
    ]
  },
  {
    id: 151,
    question: "What's your reaction to a system crash?",
    options: [
      { text: "Inspect memory dump stack trace", type: "detective" },
      { text: "Relaunch immediately & retry action", type: "sportsStar" },
      { text: "Refactor code architecture to fix bug", type: "inventor" },
      { text: "Check server status on community thread", type: "gamer" }
    ]
  },
  {
    id: 152,
    question: "You get stranded on an island. First move?",
    options: [
      { text: "Scout island perimeter map boundary", type: "spaceExplorer" },
      { text: "Build solar water distiller & shelter", type: "inventor" },
      { text: "Look for animal tracks & freshwater signs", type: "detective" },
      { text: "Sprint around to maintain high energy", type: "sportsStar" }
    ]
  },
  {
    id: 153,
    question: "Pick your ideal gaming companion app:",
    options: [
      { text: "Live FPS & frame timing grapher", type: "gamer" },
      { text: "Interactive interactive world map", type: "spaceExplorer" },
      { text: "Match damage & combat log analyzer", type: "detective" },
      { text: "Custom gear stat builder simulator", type: "inventor" }
    ]
  },
  {
    id: 154,
    question: "What's your ideal superhero origin story?",
    options: [
      { text: "Peak human athletic training mastery", type: "sportsStar" },
      { text: "Exposed to cosmic radiation in deep space", type: "spaceExplorer" },
      { text: "Genius orphan detective investigating past", type: "detective" },
      { text: "Brilliant tech builder creating exo-suit", type: "inventor" }
    ]
  },
  {
    id: 155,
    question: "How do you evaluate an ancient monument?",
    options: [
      { text: "Study star alignments with stone layouts", type: "spaceExplorer" },
      { text: "Deduce construction secrets & hidden rooms", type: "detective" },
      { text: "Analyze acoustic resonance mechanics", type: "inventor" },
      { text: "Climb steps at top speed for view", type: "sportsStar" }
    ]
  },
  {
    id: 156,
    question: "When playing a racing game, you focus on:",
    options: [
      { text: "Mastering perfect braking point timing", type: "sportsStar" },
      { text: "Tuning transmission gear ratios & suspension", type: "inventor" },
      { text: "Studying track telemetry & telemetry lines", type: "detective" },
      { text: "Using drift boosts & nitro shortcuts", type: "gamer" }
    ]
  },
  {
    id: 157,
    question: "You suspect someone modified your setup. You:",
    options: [
      { text: "Inspect desk for physical fingerprints", type: "detective" },
      { text: "Check system access audit logs", type: "inventor" },
      { text: "Test reaction feel by playing a round", type: "gamer" },
      { text: "Confront them directly with high confidence", type: "sportsStar" }
    ]
  },
  {
    id: 158,
    question: "What kind of board game piece represents you?",
    options: [
      { text: "Fast-moving Knight jumping barriers", type: "sportsStar" },
      { text: "Strategic Rook holding key lanes", type: "gamer" },
      { text: "Calculated Bishop cutting diagonals", type: "detective" },
      { text: "Pawn converting into new powerful piece", type: "inventor" }
    ]
  },
  {
    id: 159,
    question: "How do you handle a massive challenge?",
    options: [
      { text: "Attack it with high physical energy", type: "sportsStar" },
      { text: "Break it down into micro-clues", type: "detective" },
      { text: "Design a systematic execution workflow", type: "inventor" },
      { text: "Grind experience through repeated trials", type: "gamer" }
    ]
  },
  {
    id: 160,
    question: "Pick your ideal smartwatch watch face:",
    options: [
      { text: "Live heart rate & step velocity gauge", type: "sportsStar" },
      { text: "Constellation position & moon phase dial", type: "spaceExplorer" },
      { text: "Encrypted notepad & voice memo recorder", type: "detective" },
      { text: "Custom widget dashboard with battery telemetry", type: "inventor" }
    ]
  },
  {
    id: 161,
    question: "What's your preferred drone style?",
    options: [
      { text: "High-speed FPV racing drone", type: "sportsStar" },
      { text: "Long-range satellite scouting drone", type: "spaceExplorer" },
      { text: "Silent thermal imaging spy drone", type: "detective" },
      { text: "Custom 3D-printed modular payload drone", type: "inventor" }
    ]
  },
  {
    id: 162,
    question: "How do you view failure during a trial?",
    options: [
      { text: "A chance to reset & push harder", type: "sportsStar" },
      { text: "Crucial diagnostic data point", type: "inventor" },
      { text: "A detail you overlooked in plan", type: "detective" },
      { text: "Just a quick respawn opportunity", type: "gamer" }
    ]
  },
  {
    id: 163,
    question: "Which high-tech material interests you most?",
    options: [
      { text: "Ultra-lightweight carbon fiber frame", type: "sportsStar" },
      { text: "Radiation-shielding graphene alloy", type: "spaceExplorer" },
      { text: "Self-healing programmable smart polymer", type: "inventor" },
      { text: "Light-bending optical cloak optic", type: "detective" }
    ]
  },
  {
    id: 164,
    question: "You encounter a complex mathematical equation on a board:",
    options: [
      { text: "Look for logical patterns in constants", type: "detective" },
      { text: "Write script to compute solution", type: "inventor" },
      { text: "See if it calculates orbit trajectories", type: "spaceExplorer" },
      { text: "Solve it as fast as possible for record time", type: "sportsStar" }
    ]
  },
  {
    id: 165,
    question: "What's your main priority when assembling furniture?",
    options: [
      { text: "Speed-running assembly without manual", type: "sportsStar" },
      { text: "Modifying structure to improve strength", type: "inventor" },
      { text: "Checking parts list against missing items", type: "detective" },
      { text: "Following precise diagram steps", type: "gamer" }
    ]
  },
  {
    id: 166,
    question: "Pick an ideal ambient sound background:",
    options: [
      { text: "Roar of crowd in an athletic stadium", type: "sportsStar" },
      { text: "Deep space cosmic background hum", type: "spaceExplorer" },
      { text: "Quiet rain tapping on investigation office window", type: "detective" },
      { text: "Rhythmic hum of 3D printer & server fan", type: "inventor" }
    ]
  },
  {
    id: 167,
    question: "How do you handle a sudden change in plans?",
    options: [
      { text: "Pivot rapidly with athletic composure", type: "sportsStar" },
      { text: "Analyze cause of shift before acting", type: "detective" },
      { text: "Build new workaround mechanism", type: "inventor" },
      { text: "Adapt strategy build on the fly", type: "gamer" }
    ]
  },
  {
    id: 168,
    question: "What makes a mystery movie great for you?",
    options: [
      { text: "A fair clue trail where you can guess whodunit", type: "detective" },
      { text: "Insane futuristic technology gadgets", type: "inventor" },
      { text: "Fast-paced tense chase sequences", type: "sportsStar" },
      { text: "Exploration of vast mysterious locations", type: "spaceExplorer" }
    ]
  },
  {
    id: 169,
    question: "You spot a glitch in your favorite game:",
    options: [
      { text: "Exploit it to gain tactical advantage", type: "gamer" },
      { text: "Document reproduction steps to report", type: "detective" },
      { text: "Reverse engineer underlying code engine", type: "inventor" },
      { text: "Ignore it & rely on skill play", type: "sportsStar" }
    ]
  },
  {
    id: 170,
    question: "Your favorite style of footwear:",
    options: [
      { text: "High-performance running sneakers", type: "sportsStar" },
      { text: "Magnetic zero-G astronaut boots", type: "spaceExplorer" },
      { text: "Silent rubber-soled stealth boots", type: "detective" },
      { text: "Smart shoes with custom kinetic power caps", type: "inventor" }
    ]
  },
  {
    id: 171,
    question: "How do you feel about high speeds?",
    options: [
      { text: "Thrilling! Pure adrenaline surge!", type: "sportsStar" },
      { text: "Fascinating when observing orbital velocity", type: "spaceExplorer" },
      { text: "Requires precise control & telemetry", type: "inventor" },
      { text: "Fun as long as frame rates stay smooth", type: "gamer" }
    ]
  },
  {
    id: 172,
    question: "What is your reaction to an encrypted USB drive?",
    options: [
      { text: "Run password brute-force dictionary", type: "detective" },
      { text: "Extract flash memory hardware directly", type: "inventor" },
      { text: "Scan for high-level military data signatures", type: "spaceExplorer" },
      { text: "Plug into sandbox machine to explore", type: "gamer" }
    ]
  },
  {
    id: 173,
    question: "Pick your favorite team sport dynamic:",
    options: [
      { text: "Fast-passing high energy counterattacks", type: "sportsStar" },
      { text: "Tactical positioning & target calling", type: "gamer" },
      { text: "Analyzing opponent weaknesses from bench", type: "detective" },
      { text: "Designing custom team playbooks", type: "inventor" }
    ]
  },
  {
    id: 174,
    question: "What's your favorite type of puzzle object?",
    options: [
      { text: "Rubik's cube speed-solving", type: "sportsStar" },
      { text: "Interlocking metal mechanical puzzle", type: "inventor" },
      { text: "Cryptic cipher cryptex cylinder", type: "detective" },
      { text: "3D maze ball challenge", type: "gamer" }
    ]
  },
  {
    id: 175,
    question: "You are tasked with redesigning a bicycle:",
    options: [
      { text: "Make it ultra-aerodynamic for max speed", type: "sportsStar" },
      { text: "Add electric motor & regenerative braking", type: "inventor" },
      { text: "Install GPS theft tracker & security locks", type: "detective" },
      { text: "Add digital HUD speedometer display", type: "gamer" }
    ]
  },
  {
    id: 176,
    question: "What kind of reward motivates you most?",
    options: [
      { text: "First place podium trophy", type: "sportsStar" },
      { text: "Uncovering a historical hidden secret", type: "detective" },
      { text: "Launching an invention that changes lives", type: "inventor" },
      { text: "Rare legendary title & top rank", type: "gamer" }
    ]
  },
  {
    id: 177,
    question: "How do you approach learning a foreign language?",
    options: [
      { text: "Practice speaking fast with native speakers", type: "sportsStar" },
      { text: "Analyze grammar syntax & structural rules", type: "detective" },
      { text: "Build custom flashcard & spaced-repetition app", type: "inventor" },
      { text: "Gamify learning through daily quest streaks", type: "gamer" }
    ]
  },
  {
    id: 178,
    question: "You see a glowing crystal underground. First move?",
    options: [
      { text: "Analyze luminescence wavelength spectrum", type: "inventor" },
      { text: "Examine surrounding rock layer for clues", type: "detective" },
      { text: "Map crystal vein depth in cave system", type: "spaceExplorer" },
      { text: "Check if it can be mined for crafting materials", type: "gamer" }
    ]
  },
  {
    id: 179,
    question: "What's your ideal strategy card game style?",
    options: [
      { text: "Aggressive rush deck for early knockout", type: "sportsStar" },
      { text: "Control deck reading opponent's hand", type: "detective" },
      { text: "Combo deck generating infinite value engine", type: "inventor" },
      { text: "Meta deck optimized for win rate percentage", type: "gamer" }
    ]
  },
  {
    id: 180,
    question: "You get a free ticket to any event. Where do you go?",
    options: [
      { text: "World Cup / Olympic Finals", type: "sportsStar" },
      { text: "Rocket Launch Mission Control Center", type: "spaceExplorer" },
      { text: "Global Esports Championship Final", type: "gamer" },
      { text: "World Robotics & AI Summit", type: "inventor" }
    ]
  },
  {
    id: 181,
    question: "How do you react to a secret room in an old house?",
    options: [
      { text: "Search desk drawers for hidden journals", type: "detective" },
      { text: "Inspect wall mechanism that opens door", type: "inventor" },
      { text: "Explore dark passageway into unknown", type: "spaceExplorer" },
      { text: "Check room corners for hidden collectables", type: "gamer" }
    ]
  },
  {
    id: 182,
    question: "Pick your favorite type of vehicle feature:",
    options: [
      { text: "Launch control & sport tuning mode", type: "sportsStar" },
      { text: "Night-vision thermal camera sensors", type: "detective" },
      { text: "Solar roof charger & custom power inverter", type: "inventor" },
      { text: "Customizable RGB dashboard software", type: "gamer" }
    ]
  },
  {
    id: 183,
    question: "What's your mindset during an intense final exam?",
    options: [
      { text: "Power through quickly with full focus", type: "sportsStar" },
      { text: "Deduce answers logically through process of elimination", type: "detective" },
      { text: "Apply core formulas & fundamental systems", type: "inventor" },
      { text: "Speed-run questions & review flagged ones", type: "gamer" }
    ]
  },
  {
    id: 184,
    question: "Select your favorite gadget sound effect:",
    options: [
      { text: "High-tech laser charge sound", type: "inventor" },
      { text: "Subtle electronic keylock beep", type: "detective" },
      { text: "Satisfying level up sound effect", type: "gamer" },
      { text: "Powerful engine revving tone", type: "sportsStar" }
    ]
  },
  {
    id: 185,
    question: "What is your main strategy when playing hide and seek?",
    options: [
      { text: "Find an unexpected vantage spot to map seekers", type: "spaceExplorer" },
      { text: "Deduce where seeker checks first & pick opposite", type: "detective" },
      { text: "Build clever camouflage blur setup", type: "inventor" },
      { text: "Sprint between hiding spots fast", type: "sportsStar" }
    ]
  },
  {
    id: 186,
    question: "Which field of study interests you most?",
    options: [
      { text: "Exoplanetary Geology", type: "spaceExplorer" },
      { text: "Criminal Behavioral Profiling", type: "detective" },
      { text: "Autonomous Systems & Mechatronics", type: "inventor" },
      { text: "Human Movement & Athletic Kinetics", type: "sportsStar" }
    ]
  },
  {
    id: 187,
    question: "How do you handle a crowded room?",
    options: [
      { text: "Observe people dynamics & spot body language", type: "detective" },
      { text: "Move swiftly through gaps with physical ease", type: "sportsStar" },
      { text: "Identify exit points & space layout", type: "spaceExplorer" },
      { text: "Engage in social minigames & conversations", type: "gamer" }
    ]
  },
  {
    id: 188,
    question: "What's your preferred style of smartwatch notification?",
    options: [
      { text: "Vivid haptic vibration pulse", type: "sportsStar" },
      { text: "Discrete silent LED blinking light", type: "detective" },
      { text: "Custom code webhook ping", type: "inventor" },
      { text: "Audio chime with custom game sound", type: "gamer" }
    ]
  },
  {
    id: 189,
    question: "How do you evaluate a piece of software?",
    options: [
      { text: "By its responsiveness & execution speed", type: "sportsStar" },
      { text: "By its customizability & modding API", type: "inventor" },
      { text: "By its security standards & privacy audit", type: "detective" },
      { text: "By its UI smoothness & feature set", type: "gamer" }
    ]
  },
  {
    id: 190,
    question: "Pick an ideal motto to live by:",
    options: [
      { text: "Speed, Power, Victory.", type: "sportsStar" },
      { text: "Explore the Unknown Beyond.", type: "spaceExplorer" },
      { text: "Details Reveal the Whole Truth.", type: "detective" },
      { text: "Dream it, Build it, Master it.", type: "inventor" }
    ]
  },
  {
    id: 191,
    question: "You see an abandoned factory. What do you check first?",
    options: [
      { text: "Inspect leftover equipment & raw materials", type: "inventor" },
      { text: "Look for footprints & sign of recent intrusion", type: "detective" },
      { text: "Chart the full floor layout & structure", type: "spaceExplorer" },
      { text: "Test physical echo & run floor space", type: "sportsStar" }
    ]
  },
  {
    id: 192,
    question: "What kind of puzzle book would you buy?",
    options: [
      { text: "Lateral thinking & detective mysteries", type: "detective" },
      { text: "Circuit diagrams & logic gate challenges", type: "inventor" },
      { text: "Rapid reaction word & speed grids", type: "sportsStar" },
      { text: "Complex Sudoku & number matrix grids", type: "gamer" }
    ]
  },
  {
    id: 193,
    question: "When presented with a hard decision, you rely on:",
    options: [
      { text: "Lightning fast instinctive gut feel", type: "sportsStar" },
      { text: "Solid verified evidence & data facts", type: "detective" },
      { text: "Building a pros/cons scoring matrix model", type: "inventor" },
      { text: "Calculated risk-reward odds", type: "gamer" }
    ]
  },
  {
    id: 194,
    question: "Pick your ideal sci-fi job title:",
    options: [
      { text: "Deep Space Recon Pilot", type: "spaceExplorer" },
      { text: "Interstellar Forensics Investigator", type: "detective" },
      { text: "Chief Cybernetics Architect", type: "inventor" },
      { text: "Pro Esports Combat Strategist", type: "gamer" }
    ]
  },
  {
    id: 195,
    question: "How do you approach a new fitness challenge?",
    options: [
      { text: "Go all out with high physical energy", type: "sportsStar" },
      { text: "Log exact biometric metric daily trends", type: "detective" },
      { text: "Design custom workout tracking gear", type: "inventor" },
      { text: "Treat workouts like XP grinding sessions", type: "gamer" }
    ]
  },
  {
    id: 196,
    question: "You find an uncharted island on satellite images:",
    options: [
      { text: "Organize an expedition team to explore it", type: "spaceExplorer" },
      { text: "Investigate military history of the island coordinates", type: "detective" },
      { text: "Analyze satellite spectral reflection data", type: "inventor" },
      { text: "Search if it's featured in any game maps", type: "gamer" }
    ]
  },
  {
    id: 197,
    question: "What's your primary strategy when buying tools?",
    options: [
      { text: "Get high-end pro grade gear built for speed", type: "sportsStar" },
      { text: "Verify build quality & user review details", type: "detective" },
      { text: "Choose versatile tools you can customize", type: "inventor" },
      { text: "Compare feature stat sheets across brands", type: "gamer" }
    ]
  },
  {
    id: 198,
    question: "How do you feel when faced with an unknown problem?",
    options: [
      { text: "Excited to test your limits & win!", type: "sportsStar" },
      { text: "Curious to investigate root cause details", type: "detective" },
      { text: "Eager to design an original solution device", type: "inventor" },
      { text: "Ready to figure out mechanics & overcome", type: "gamer" }
    ]
  },
  {
    id: 199,
    question: "Pick your preferred gaming display setting:",
    options: [
      { text: "Maximum FPS performance mode", type: "sportsStar" },
      { text: "Ultra 4K resolution cinematic mode", type: "spaceExplorer" },
      { text: "Balanced latency & detail profile", type: "detective" },
      { text: "Custom color & HUD overlay profile", type: "inventor" }
    ]
  },
  {
    id: 200,
    question: "How do you feel after solving a super hard problem?",
    options: [
      { text: "Pumped! Like winning a championship game!", type: "sportsStar" },
      { text: "Satisfied that the truth was revealed!", type: "detective" },
      { text: "Proud of the functional system you created!", type: "inventor" },
      { text: "Victorious! Time to collect rewards & level up!", type: "gamer" }
    ]
  }
];